module.exports = __webpack_public_path__ + "img/icon-groupe-negatif.f4a6e6c9.svg";